import { useEffect } from "react";

import { useFeatureFlags } from "@atlassiansox/bxp-content-framework";

import {
    AnalyticsAttributesProvider,
    useAnalytics,
    useAnalyticsAttributes
} from "../../components";
import { UiVariationContainerModel } from "../../models";
import { renderViewModels } from "../../render-view-model";

export type UiVariationContainerProps = {
    readonly model: UiVariationContainerModel;
};

const UiVariationContainer = ({ model }: UiVariationContainerProps) => {
    const { sendTrackEvent } = useAnalytics();
    const analyticsAttributes = useAnalyticsAttributes();

    const { featureFlagName, variations, defaultVariation } = model.content;

    const flags = useFeatureFlags();

    const variant = variations?.find(
        ({ content }) =>
            content && content.variationValue === flags[content.variationName]
    );

    useEffect(() => {
        sendTrackEvent("renderedWithVariants", {
            eventContainer: "content",
            ...analyticsAttributes,
            event: "rendered",
            eventComponent: "uiVariationContainer",
            label: featureFlagName,
            labelEnglish: featureFlagName,
            uuid: model.id,
            containerVariant: variant?.content.variationValue ?? "default"
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps -- TODO: add missing dependencies
    }, [sendTrackEvent]);

    if (variant)
        return (
            <AnalyticsAttributesProvider
                value={{
                    containerVariant: variant.content.variationValue
                }}
            >
                {renderViewModels(variant.content.variation)}
            </AnalyticsAttributesProvider>
        );

    return (
        <AnalyticsAttributesProvider
            value={{
                containerVariant: "default"
            }}
        >
            {defaultVariation ? renderViewModels(defaultVariation) : null}
        </AnalyticsAttributesProvider>
    );
};

export default UiVariationContainer;
